import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { PulseComponent } from './pulse.component';

export const PulseRoutes: Routes = [
    {
        path: 'pulse',
        component: PulseComponent,
        canActivate: [AuthService],
    },
];
